
const ACCESS_STORAGE_KEY = "access";
const REFRESH_STORAGE_KEY = "refresh";

const SESSION_HINT = "session_hint";

const tokenStore = localStorage;

export const getAccessToken = () =>
  tokenStore.getItem(ACCESS_STORAGE_KEY);

export const getRefreshToken = () =>
  tokenStore.getItem(REFRESH_STORAGE_KEY);

export const setTokens = (access, refresh) => {
  if (access) {
    tokenStore.setItem(ACCESS_STORAGE_KEY, access);
  }

  if (refresh) {
    tokenStore.setItem(REFRESH_STORAGE_KEY, refresh);
  }

  if (access || refresh) {
    markSessionActive();
  }
};

export const markSessionActive = () => {
  localStorage.setItem(SESSION_HINT, "1");
};

export const clearTokens = () => {
  localStorage.removeItem(ACCESS_STORAGE_KEY);
  localStorage.removeItem(REFRESH_STORAGE_KEY);
  localStorage.removeItem(SESSION_HINT);

  // Clean up tokens left by older sessionStorage-based builds.
  sessionStorage.removeItem(ACCESS_STORAGE_KEY);
  sessionStorage.removeItem(REFRESH_STORAGE_KEY);
};

export const isAuthenticated = () =>
  Boolean(getAccessToken() || getRefreshToken());
